/**
 * Standard error rendering for chat + project pages.
 *
 * Replaces the v1 inline `<div className="error">{msg}</div>` pattern
 * with a reusable component that supports a `budget` variant for
 * daily-limit exhaustion messages (different colour, distinct copy).
 *
 * Variants:
 *   - "error"  (default) — red, general failure
 *   - "budget" — amber, daily token limit reached
 */
export default function ErrorBubble({ message, variant = "error" }) {
  if (!message) return null;
  return (
    <div className={`error-bubble error-bubble-${variant}`} role="alert">
      {message}
    </div>
  );
}
